"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view(props) {
    return {
        state: {},
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onNext: this.props.onNext,
            onPrev: this.props.onPrev
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsNavigation/View.js
// module id = 972
// module chunks = 0